import { useState, useEffect, useCallback } from 'react';
import { merchantApi } from '../api/config';

interface TodayFees {
  today_fee: number;
  today_payin_fee: number;
  today_payout_fee: number;
  pending_orders: number;
}

const DEFAULT_FEES: TodayFees = {
  today_fee: 0,
  today_payin_fee: 0,
  today_payout_fee: 0,
  pending_orders: 0,
};

export function useAdminLayoutFees(intervalMs = 30000) {
  const [fees, setFees] = useState<TodayFees>(DEFAULT_FEES);

  const loadFees = useCallback(async () => {
    try {
      const res = await merchantApi.get('/admin/today-fees');
      if (res.data?.data) setFees(res.data.data);
    } catch {
      console.error('Failed to load today fees');
    }
  }, []);

  useEffect(() => {
    loadFees();
    const id = setInterval(loadFees, intervalMs);
    return () => clearInterval(id);
  }, [loadFees, intervalMs]);

  return fees;
}
